import React from 'react';
import styled from 'styled-components';
import Button from '../components/common/Button';
import FeatureBlock from '../components/common/FeatureBlock';
import Card from '../components/common/Card';

// Imagens temporárias (serão substituídas por imagens reais)
const agentImage = 'https://via.placeholder.com/600x400?text=Agent';
const discoverImage = 'https://via.placeholder.com/500x300?text=Discover+Agent';
const solveImage = 'https://via.placeholder.com/500x300?text=Solve+Agent';
const triageImage = 'https://via.placeholder.com/500x300?text=Triage+Agent';
const assistImage = 'https://via.placeholder.com/500x300?text=Assist+Agent';

const AgentsPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <AgentsHero>
        <AgentsHeroContent>
          <AgentsHeroTitle>Agentes de IA para Experiência do Cliente Empresarial</AgentsHeroTitle>
          <AgentsHeroSubtitle>
            Transforme seu atendimento ao cliente com agentes de IA que entendem, resolvem e aprimoram cada interação
          </AgentsHeroSubtitle>
          <AgentsHeroActions>
            <Button size="large">Solicite uma Demo</Button>
            <Button variant="secondary" size="large">Saiba Mais</Button>
          </AgentsHeroActions>
        </AgentsHeroContent>
      </AgentsHero>

      {/* Agents Overview Section */}
      <Section>
        <SectionTitle>Sistema Multi-Agente Leadfy</SectionTitle>
        <SectionDescription>
          Nossa plataforma de IA utiliza um sistema multi-agente para fornecer suporte abrangente e inteligente em todos os pontos de contato com o cliente.
        </SectionDescription>
        
        <AgentsGrid>
          <AgentCard>
            <AgentIcon>🔍</AgentIcon>
            <AgentTitle>Discover Agent</AgentTitle>
            <AgentDescription>
              Insights de IA para identificar lacunas de conhecimento e oportunidades de melhoria no atendimento ao cliente.
            </AgentDescription>
            <AgentLink href="/platform/discover">Saiba mais</AgentLink>
          </AgentCard>
          
          <AgentCard>
            <AgentIcon>🛠️</AgentIcon>
            <AgentTitle>Solve Agent</AgentTitle>
            <AgentDescription>
              Agente de IA omnichannel que resolve problemas de clientes automaticamente em todos os canais.
            </AgentDescription>
            <AgentLink href="/platform/solve">Saiba mais</AgentLink>
          </AgentCard>
          
          <AgentCard>
            <AgentIcon>🔄</AgentIcon>
            <AgentTitle>Triage Agent</AgentTitle>
            <AgentDescription>
              Classificação inteligente de tickets para direcionar cada solicitação para o recurso mais adequado.
            </AgentDescription>
            <AgentLink href="/platform/triage">Saiba mais</AgentLink>
          </AgentCard>
          
          <AgentCard>
            <AgentIcon>👨‍💼</AgentIcon>
            <AgentTitle>Assist Agent</AgentTitle>
            <AgentDescription>
              Copiloto de IA agêntico que capacita agentes humanos com análises e recomendações em tempo real.
            </AgentDescription>
            <AgentLink href="/platform/assist">Saiba mais</AgentLink>
          </AgentCard>
        </AgentsGrid>
      </Section>

      {/* Discover Agent Section */}
      <Section background="light">
        <FeatureBlock
          title="Discover Agent"
          description="Insights de IA para identificar lacunas de conhecimento e oportunidades de melhoria no atendimento ao cliente."
          image={discoverImage}
          imagePosition="right"
          features={[
            {
              title: "Análise de Lacunas de Conhecimento",
              description: "Identifica automaticamente áreas onde sua base de conhecimento precisa ser aprimorada."
            },
            {
              title: "Geração de Conteúdo",
              description: "Cria artigos e respostas para preencher lacunas de conhecimento identificadas."
            },
            {
              title: "Insights Acionáveis",
              description: "Fornece recomendações baseadas em dados para melhorar o atendimento ao cliente."
            }
          ]}
          actions={<Button>Saiba mais sobre o Discover Agent</Button>}
        />
      </Section>

      {/* Solve Agent Section */}
      <Section>
        <FeatureBlock
          title="Solve Agent"
          description="Agente de IA omnichannel que resolve problemas de clientes automaticamente em todos os canais."
          image={solveImage}
          imagePosition="left"
          features={[
            {
              title: "Resolução Automática",
              description: "Resolve problemas comuns de clientes sem intervenção humana."
            },
            {
              title: "Suporte Omnichannel",
              description: "Funciona perfeitamente em e-mail, chat, voz e plataformas de mensagens."
            },
            {
              title: "Personalização Contextual",
              description: "Adapta respostas com base no histórico do cliente e no contexto da conversa."
            }
          ]}
          actions={<Button>Saiba mais sobre o Solve Agent</Button>}
        />
      </Section>

      {/* Triage Agent Section */}
      <Section background="light">
        <FeatureBlock
          title="Triage Agent"
          description="Classificação inteligente de tickets para direcionar cada solicitação para o recurso mais adequado."
          image={triageImage}
          imagePosition="right"
          features={[
            {
              title: "Classificação Automática",
              description: "Categoriza tickets com base em conteúdo, urgência e complexidade."
            },
            {
              title: "Roteamento Inteligente",
              description: "Direciona solicitações para o agente ou departamento mais qualificado."
            },
            {
              title: "Priorização Dinâmica",
              description: "Ajusta prioridades com base em SLAs, sentimento do cliente e outros fatores."
            }
          ]}
          actions={<Button>Saiba mais sobre o Triage Agent</Button>}
        />
      </Section>

      {/* Assist Agent Section */}
      <Section>
        <FeatureBlock
          title="Assist Agent"
          description="Copiloto de IA agêntico que capacita agentes humanos com análises e recomendações em tempo real."
          image={assistImage}
          imagePosition="left"
          features={[
            {
              title: "Sugestões em Tempo Real",
              description: "Fornece recomendações de respostas e ações durante interações com clientes."
            },
            {
              title: "Acesso Rápido ao Conhecimento",
              description: "Recupera informações relevantes da base de conhecimento instantaneamente."
            },
            {
              title: "Análise de Sentimento",
              description: "Detecta emoções do cliente e sugere abordagens apropriadas."
            }
          ]}
          actions={<Button>Saiba mais sobre o Assist Agent</Button>}
        />
      </Section>

      {/* Security & Compliance Section */}
      <Section background="light">
        <SectionTitle>Segurança e Conformidade</SectionTitle>
        <SectionDescription>
          A Leadfy prioriza a segurança e privacidade dos dados, garantindo que todas as interações de IA sejam seguras e em conformidade com regulamentações.
        </SectionDescription>
        
        <SecurityGrid>
          <SecurityCard>
            <SecurityIcon>🔒</SecurityIcon>
            <SecurityTitle>Criptografia de Dados</SecurityTitle>
            <SecurityDescription>
              Todos os dados são criptografados em trânsito e em repouso, garantindo proteção máxima.
            </SecurityDescription>
          </SecurityCard>
          
          <SecurityCard>
            <SecurityIcon>📜</SecurityIcon>
            <SecurityTitle>Conformidade Regulatória</SecurityTitle>
            <SecurityDescription>
              Em conformidade com GDPR, CCPA, HIPAA e outras regulamentações relevantes.
            </SecurityDescription>
          </SecurityCard>
          
          <SecurityCard>
            <SecurityIcon>🛡️</SecurityIcon>
            <SecurityTitle>Controles de Acesso</SecurityTitle>
            <SecurityDescription>
              Controles granulares de acesso e autenticação multifator para proteger dados sensíveis.
            </SecurityDescription>
          </SecurityCard>
          
          <SecurityCard>
            <SecurityIcon>🔍</SecurityIcon>
            <SecurityTitle>Auditoria e Monitoramento</SecurityTitle>
            <SecurityDescription>
              Monitoramento contínuo e trilhas de auditoria para todas as atividades do sistema.
            </SecurityDescription>
          </SecurityCard>
        </SecurityGrid>
        
        <CenteredButton>
          <Button variant="secondary">Saiba mais sobre Segurança</Button>
        </CenteredButton>
      </Section>

      {/* CTA Section */}
      <Section>
        <SectionTitle>Transforme seu Atendimento ao Cliente com IA</SectionTitle>
        <SectionDescription>
          Descubra como os agentes de IA da Leadfy podem revolucionar sua experiência do cliente e impulsionar resultados de negócios.
        </SectionDescription>
        
        <CenteredButton>
          <Button size="large">Solicite uma Demo</Button>
        </CenteredButton>
      </Section>
    </div>
  );
};

// Styled Components
const AgentsHero = styled.section`
  background-color: var(--primary-dark);
  padding: var(--spacing-xxl) 0;
  color: var(--white);
`;

const AgentsHeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  padding: 0 var(--spacing-lg);
`;

const AgentsHeroTitle = styled.h1`
  font-size: var(--font-size-4xl);
  margin-bottom: var(--spacing-lg);
`;

const AgentsHeroSubtitle = styled.p`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-xl);
  opacity: 0.9;
`;

const AgentsHeroActions = styled.div`
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Section = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: ${props => props.background === 'light' ? 'var(--light-bg)' : 'var(--white)'};
`;

const SectionTitle = styled.h2`
  font-size: var(--font-size-3xl);
  text-align: center;
  margin-bottom: var(--spacing-lg);
  color: var(--primary-dark);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionDescription = styled.p`
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const AgentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AgentCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
  transition: transform var(--transition-normal), box-shadow var(--transition-normal);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const AgentIcon = styled.div`
  font-size: 3rem;
  margin-bottom: var(--spacing-md);
`;

const AgentTitle = styled.h3`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const AgentDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-lg);
`;

const AgentLink = styled.a`
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const SecurityGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SecurityCard = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-lg);
  text-align: center;
`;

const SecurityIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: var(--spacing-md);
  color: var(--primary);
`;

const SecurityTitle = styled.h3`
  font-size: var(--font-size-lg);
  margin-bottom: var(--spacing-md);
  color: var(--primary-dark);
`;

const SecurityDescription = styled.p`
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

const CenteredButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-xl);
`;

export default AgentsPage;
